import script from "./BarCodeReaderWebComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarCodeReaderWebComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BarCodeReaderWebComponent.vue?vue&type=style&index=0&id=6d2db53f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2db53f"]])

export default __exports__